import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';

import { TruncateTooltipDirective } from './truncate-tooltip.directive';
import { TruncateTooltipComponent } from './truncate-tooltip.component';
import { TooltipDirective } from './tooltip.directive';

@NgModule({
  declarations: [TruncateTooltipDirective, TooltipDirective, TruncateTooltipComponent],
  imports: [CommonModule, OverlayModule],
  exports: [TruncateTooltipDirective, TooltipDirective],
  entryComponents: [TruncateTooltipComponent]
})
export class TruncateTooltipModule {
}
